export const deleteItemModal = {
  title: '¿Deseas eliminar este elemento?',
  body: 'Al dar click en confirmar se eliminará y esta acción no se podrá deshacer',
};

export const clearCancellationsModal = {
  title: '¿Deseas limpiar las cancelaciones este cliente?',
  body: 'Está realizando una excepción para este cliente. Si vuelve a incurrir en una nueva causa de baneo, ya no podrá ser desbaneado nuevamente por gerencia de forma directa y solo podrá liberarse mediante código autorizado o el cliente deberá realizar una compra previa antes de poder agendar.',
};

export const recurrentCustomerUnbanMessage =
  'Este cliente ya presenta reincidencia en condición de baneo. El desbaneo solo podrá realizarse mediante código autorizado o el cliente deberá realizar una compra previa antes de poder agendar. El código únicamente será proporcionado en casos totalmente justificados.';

export const orderConfirmModal = {
  title: '¿Deseas confirmar esta orden?',
  body: 'Al dar click en aceptar se estará generando la orden',
};

export const modalButtons = {
  ok: 'Aceptar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
};

export const rejectProductModal = {
  title: '¿Deseas rechazar este producto?',
  body: 'Al dar click en rechazar, el producto se rechazará y necesitara guardarse de nuevo para pedir aprobación',
};

export const cancelConsigmentOrderBillingModal = {
  title: '¿Deseas cancelar esta factura de consignación?',
  body: 'Al dar click en confirmar se cancelará la factura y esta acción no se podrá deshacer',
};

export const cancelConsigmentOrderRefundModal = {
  title: '¿Deseas cancelar esta devolucion de consignación?',
  body: 'Al dar click en confirmar se cancelará la devolucion y esta acción no se podrá deshacer',
};

export const approveConsigmentOrder = {
  title: '¿Deseas aprobar esta orden de consignación?',
  body: 'Al dar click en confirmar se aprobará la orden de consignación y esta acción no se podrá deshacer',
};

export const noApproveConsigmentOrder = {
  title: 'No se puede aprobar esta orden de consignación',
  body: 'La orden de consignación no puede ser aprobada debido a que hay movimientos pendientes o hay productos no facturados',
};

export const freezeScreenModal = {
  title: 'Tiempo limite de inactividad alcanzado',
  body: 'Da click en continuar para seguir trabajando',
};

export const updateCommisionsModal = {
  title: 'Actualizar comisiones',
  body: 'Se actualizará la configuración de comisiones y las comisiones de la catorcena en curso, una vez aplicado el cambio no habrá vuelta atrás',
};

export const calendarModal = {
  title: 'Citas del horario',
};
